import { render } from "./KoiList.vue?vue&type=template&id=4129a49b&scoped=true&ts=true"
import script from "./KoiList.vue?vue&type=script&lang=ts"
export * from "./KoiList.vue?vue&type=script&lang=ts"

import "./KoiList.vue?vue&type=style&index=0&id=4129a49b&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/olaria-client/olaria-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4129a49b"]])

export default __exports__